"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const Icon_1 = __importDefault(require("./Icon"));
function FolderRenameOutlineIcon(props) {
    return (react_1.default.createElement(Icon_1.default, Object.assign({}, props),
        react_1.default.createElement("path", { d: "M19.741,21.284H3.217A1.949,1.949,0,0,1,1.27,19.338V7.224A1.95,1.95,0,0,1,3.217,5.277H6.935a1.935,1.935,0,0,1,1.376.57L9.722,7.259a.354.354,0,0,0,.245.1H15.2v1.6H9.967a1.96,1.96,0,0,1-1.375-.57L7.181,6.978a.346.346,0,0,0-.246-.1H3.217a.348.348,0,0,0-.347.347V19.338a.347.347,0,0,0,.347.346H19.741a.348.348,0,0,0,.348-.346V13.969h1.6v5.369A1.949,1.949,0,0,1,19.741,21.284Z" }),
        react_1.default.createElement("polygon", { points: "20.888 3.895 14.583 12.662 14.021 16.107 17.102 14.469 23.407 5.701 20.888 3.895" })));
}
exports.default = FolderRenameOutlineIcon;
